"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_EDITORIALS_PATHNAME = exports.APP_TEAM_NAME = exports.APP_NAME = exports.APPLICATION_NAME = void 0;
var _testidGenerator = require("@ori/testid-generator");
/**
 * Name of this app.
 */ const APP_NAME = exports.APP_NAME = 'editorial-category';
const APPLICATION_NAME = exports.APPLICATION_NAME = "@ori/".concat(APP_NAME);
/**
 * Team which owns this SPA.
 */ const APP_TEAM_NAME = exports.APP_TEAM_NAME = _testidGenerator.Team.Presentation;
const DEFAULT_EDITORIALS_PATHNAME = exports.DEFAULT_EDITORIALS_PATHNAME = '/campaigns/editorials';
